/**
 * EN content for the "Menton – Italian Riviera" private excursion.
 *
 * Role: English translation of slugs/riviera-italienne.ts, typed
 * `ExcursionPage` for the shared ExcursionSlugView.
 * Dependencies: slug-excursions (type), image. Slug mirrors FR
 * ("riviera-italienne") to keep the FR↔EN canonical join stable.
 */
import type { ExcursionPage } from "../slug-excursions";
import menton from "@/assets/images/excursions/destinations/menton.webp";

const page: ExcursionPage = {
  slug: "riviera-italienne",
  hero: {
    title: "Menton – Italian Riviera Excursion",
    subtitle:
      "Pastel colours and dolce vita between Menton and the Italian border.",
    ctaPrimaryHref: "/en/reservation",
    ctaPrimaryLabel: "Book now",
    ctaSecondaryHref: "/contact",
    ctaSecondaryLabel: "Get a quote",
    image: menton,
  },
  highlights: {
    title: "Highlights",
    items: [
      { text: "Menton: pastel façades and seafront" },
      { text: "Dolce vita on the Italian side, local specialities" },
      { text: "Gardens, villas and sea views" },
      { text: "Italian markets (day dependent)" },
    ],
  },
  itinerary: {
    title: "Sample itinerary",
    steps: [
      {
        title: "Menton",
        description: "Old town, basilica, seafront.",
      },
      {
        title: "Ventimiglia (day dependent)",
        description: "Market, Italian specialities.",
      },
      {
        title: "Bordighera (optional)",
        description: "Promenade, villas, cafés.",
      },
      {
        title: "Milan (optional, full-day)",
        description:
          "Extension on request with an optimised itinerary from the Italian Riviera.",
      },
    ],
  },
  practical: {
    title: "Practical information",
    items: [
      { label: "Duration", value: "4 to 7 hours" },
      { label: "Documents", value: "ID card / passport" },
      { label: "Departure", value: "Cannes" },
      { label: "Extension", value: "Milan on request" },
      { label: "Currency", value: "Euro (Italy)" },
    ],
  },
  seo: {
    title: "Menton – Italian Riviera Excursion | Private Chauffeur",
    description:
      "Private excursion from Cannes to Menton and the Italian Riviera: pastel façades, dolce vita, Italian markets and an optional Milan extension.",
    canonical: "/en/excursions/riviera-italienne",
  },
};

export default page;
